import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/reset.css';

// 导入 bootstrap 样式表
import './assets/css/bootstrap.css'
// 导入全局自定义样式表
import './index.css'
// 导入别人的样式
import '@fortawesome/fontawesome-free/css/all.css';
import './assets/css/common.css'

const app = createApp(App)
app.use(Antd);
app.use(router)
app.mount('#app')